var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable } from 'mobx';
import { api } from '../../helpers/Api';
import { PaymentMethod } from './Model';
import { TicketPayment } from '../../Models/TicketPayment';
var TempDuePaymentsStore = /** @class */ (function () {
    function TempDuePaymentsStore() {
        var _this = this;
        this.init = function () {
            _this._amountCash = 0;
            _this._amountCard = 0;
            _this._amountTransfer = 0;
            _this._amountOther = 0;
            _this._totalDue = null;
        };
        this.send = function (item) {
            return api.post("/ticketPaymentDue/".concat(item.numero), _this).then(function (value) {
                if (value.result === 'ok') {
                    _this.reset();
                }
                return value;
            });
        };
        this.sendPaymentOrder = function (item, user) {
            console.log('sendPaymentOrder');
            var data = {
                ticandoUser: user.username,
                ticandoUser_id: _this.user.id,
                paymentCard_id: _this.paymentSelected.id
            };
            return api.post("/payment/ticket/order/".concat(item.numero, "?pasarelaPago=").concat(PaymentGateways.MSP, "&environment=").concat(process.env.REACT_APP_ENVIRONMENT), data).then(function (value) {
                if (value.result === 'ok') {
                    _this.reset();
                }
                return value;
            });
        };
        this.init();
    }
    Object.defineProperty(TempDuePaymentsStore.prototype, "amountCash", {
        // getters
        get: function () {
            return this._amountCash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TempDuePaymentsStore.prototype, "amountCard", {
        get: function () {
            return this._amountCard;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TempDuePaymentsStore.prototype, "amountTransfer", {
        get: function () {
            return this._amountTransfer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TempDuePaymentsStore.prototype, "amountOther", {
        get: function () {
            return this._amountOther;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TempDuePaymentsStore.prototype, "totalToDue", {
        get: function () {
            return this._amountCash + this._amountCard + this._amountTransfer + this._amountOther;
        },
        enumerable: false,
        configurable: true
    });
    TempDuePaymentsStore.prototype.reset = function () {
        this.init();
    };
    // setters
    TempDuePaymentsStore.prototype.setTotalDue = function (totalDue) {
        this._totalDue = totalDue;
    };
    TempDuePaymentsStore.prototype.setAllMoneyToPaymentMethod = function (method) {
        console.log('setAllMoneyToPaymentMethod - method: ', method);
        if (!method || this._totalDue === null) {
            return;
        }
        switch (method) {
            case PaymentMethod.Cash:
                this.setAllMoneyToCash();
                break;
            case PaymentMethod.Card:
                this.setAllMoneyToCard();
                break;
            case PaymentMethod.Transfer:
                this.setAllMoneyToTransfer();
                break;
            case PaymentMethod.Other:
                this.setAllMoneyToOther();
                break;
            default:
        }
    };
    TempDuePaymentsStore.prototype.setAllMoneyToCash = function () {
        this._amountCash = this._totalDue;
        this._amountCard = 0;
        this._amountTransfer = 0;
        this._amountOther = 0;
    };
    TempDuePaymentsStore.prototype.setAllMoneyToCard = function () {
        this._amountCash = 0;
        this._amountCard = this._totalDue;
        this._amountTransfer = 0;
        this._amountOther = 0;
    };
    TempDuePaymentsStore.prototype.setAllMoneyToTransfer = function () {
        this._amountCash = 0;
        this._amountCard = 0;
        this._amountTransfer = this._totalDue;
        this._amountOther = 0;
    };
    TempDuePaymentsStore.prototype.setAllMoneyToOther = function () {
        this._amountCash = 0;
        this._amountCard = 0;
        this._amountTransfer = 0;
        this._amountOther = this._totalDue;
    };
    TempDuePaymentsStore.prototype.setPayment = function (method, amount) {
        switch (method) {
            case PaymentMethod.Cash:
                this._amountCash = amount;
                break;
            case PaymentMethod.Card:
                this._amountCard = amount;
                break;
            case PaymentMethod.Transfer:
                this._amountTransfer = amount;
                break;
            case PaymentMethod.Other:
                this._amountOther = amount;
                break;
            default:
        }
    };
    TempDuePaymentsStore.prototype.toJSON = function () {
        var payments = [];
        if (this._amountCash > 0) {
            var tempPayment = new TicketPayment(PaymentMethod.Cash);
            tempPayment.setAmount(this._amountCash);
            tempPayment.user = this.user.username;
            tempPayment.user_id = this.user.id;
            tempPayment.terminal = this.terminal;
            payments.push(tempPayment);
        }
        if (this._amountCard > 0) {
            var tempPayment = new TicketPayment(PaymentMethod.Card);
            tempPayment.setAmount(this._amountCard);
            tempPayment.user = this.user.username;
            tempPayment.user_id = this.user.id;
            tempPayment.terminal = this.terminal;
            tempPayment.gateway = this.paymentSelected.gateway;
            tempPayment.token = this.paymentSelected.token;
            payments.push(tempPayment);
        }
        if (this._amountTransfer > 0) {
            var tempPayment = new TicketPayment(PaymentMethod.Transfer);
            tempPayment.setAmount(this._amountTransfer);
            tempPayment.user = this.user.username;
            tempPayment.user_id = this.user.id;
            tempPayment.terminal = this.terminal;
            tempPayment.gateway = this.paymentSelected.gateway;
            tempPayment.token = this.paymentSelected.token;
            payments.push(tempPayment);
        }
        if (this._amountOther > 0) {
            var tempPayment = new TicketPayment(PaymentMethod.Other);
            tempPayment.setAmount(this._amountOther);
            tempPayment.user = this.user.username;
            tempPayment.user_id = this.user.id;
            tempPayment.terminal = this.terminal;
            payments.push(tempPayment);
        }
        return {
            payments: payments
        };
    };
    __decorate([
        observable
    ], TempDuePaymentsStore.prototype, "_totalDue", void 0);
    __decorate([
        observable
    ], TempDuePaymentsStore.prototype, "_amountCash", void 0);
    __decorate([
        observable
    ], TempDuePaymentsStore.prototype, "_amountCard", void 0);
    __decorate([
        observable
    ], TempDuePaymentsStore.prototype, "_amountTransfer", void 0);
    __decorate([
        observable
    ], TempDuePaymentsStore.prototype, "_amountOther", void 0);
    __decorate([
        computed
    ], TempDuePaymentsStore.prototype, "totalToDue", null);
    __decorate([
        action
    ], TempDuePaymentsStore.prototype, "reset", null);
    __decorate([
        action
    ], TempDuePaymentsStore.prototype, "init", void 0);
    __decorate([
        action
    ], TempDuePaymentsStore.prototype, "setTotalDue", null);
    __decorate([
        action
    ], TempDuePaymentsStore.prototype, "setAllMoneyToPaymentMethod", null);
    __decorate([
        action
    ], TempDuePaymentsStore.prototype, "setAllMoneyToCash", null);
    __decorate([
        action
    ], TempDuePaymentsStore.prototype, "setAllMoneyToCard", null);
    __decorate([
        action
    ], TempDuePaymentsStore.prototype, "setAllMoneyToTransfer", null);
    __decorate([
        action
    ], TempDuePaymentsStore.prototype, "setAllMoneyToOther", null);
    __decorate([
        action
    ], TempDuePaymentsStore.prototype, "setPayment", null);
    return TempDuePaymentsStore;
}());
export { TempDuePaymentsStore };
export var PaymentGateways = Object.freeze({
    TMT: 'TRUSTMYTRAVEL',
    MSP: 'MULTISAFEPAY',
    PNP: 'PAYNOPAIN',
    STRIPE: 'STRIPE',
    GREENPAY: 'GREEPAY',
    CREDOMATIC: 'CREDOMATIC'
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/TempDuePaymentsStore.ts
// module id = 746
// module chunks = 0